import React from 'react';

import { TenantBreadcrumbs } from '~/components/Header/Header.desktop/TenantBreadcrumbs';

export const TenantHeaderMobile = () => {
    return <TenantBreadcrumbs />;
};
